import { useContext } from "react";
import { useSelector } from "react-redux";
import {
  RetrieveProjectsFilter,
  Identifiable,
  Project,
  Sort,
  Zone,
} from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  projects: Identifiable<Project>[];
  canRetrieveNextProjects: boolean;
  index: number;
  retrieveProjects(request: Boundaries["retrieveProjects"]["request"]): void;
}

function useRetrieveProjects(
  filter: RetrieveProjectsFilter,
  sort: Sort,
  size: number,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectsRequestPending(filter, sort, size),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectsRequestSuccess(filter, sort, size),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectsRequestFailure(filter, sort, size),
    ),
    projects: useSelector(() => selector.getProjects(filter, sort, size)),
    canRetrieveNextProjects: useSelector(() =>
      selector.canRetrieveProjects(filter, sort, size),
    ),
    index: useSelector(() =>
      selector.getRetrieveProjectsIndex(filter, sort, size),
    ),
    retrieveProjects: core.retrieveProjects,
  };
}

export { useRetrieveProjects };
